import React from 'react';
import './ApplyFiltersButton.css';

const ApplyFiltersButton = ({ hasFilters, onApply }) => {
  if (!hasFilters) return null;

  return (
    <div className="apply_filters_container">
      <button 
        className="apply_filters_btn" 
        onClick={onApply}
      >
        Apply Filters
      </button>
    </div>
  );
};

export default ApplyFiltersButton;
